define(function() {
    const IpsModelCollection = require('civicsBase/ipsModelCollection');
    const utils = require('civicsUtils/general_utilities');
    const ViewManager = require('civicsUtils/view_manager');
	const instrument_utilities = require('civicsUtils/instrument_utilities');

    const AvailableFeatures = require('civicsUtils/available_features');
    return IpsModelCollection.extend({
        urlRoot: '/delegate/civics-api/api/',
        completed: function() {
            var filtered = this.filter(function(model) {
                return model.get('completed') === true;
            });
            return new IpsModelCollection(filtered);
        },
        url: function() {
            //console.log ('URL Attributes','itemType:',this.itemType,'instrumentType:',this.instrumentType,'id:',this.id,'commonID',this.commonID);
            switch (this.itemType.toLowerCase()) {
                case 'inspections':
                    if (this.instrumentType && this.id) {
                        return this.urlRoot + 'cdr/applications/' + this.instrumentType + '/' + this.id + '/inspections?Page=[{Max:0}]&Select=[id,Application,AssignedToProvider.Identity.FirstName,AssignedToProvider.Identity.LastName,AssignedToProvider.id,CallDateTime,CompletedDateTime,Comments,ContactInfo,ContactPerson,InspectionType.Id,InspectionType.Description,InspectionType.PortalDescription,InspectionTypeNumber,IsPartial,Location,RequestedBy.MembershipKey,Result,ResultDateTime,ResultDescription,ScheduledDateTime,ServiceProviders,SpecialInstructions,StartDateTime,TimePreference,TimePreferenceDescription,Type]';
                    }
                    break;
                case 'fees':
                    if (this.commonID) {
                          return this.urlRoot + 'cdr/common/applications/' + this.commonID + '/fees?Select=[paidDateTime]&Page=[{Max:0}]';
                    }
                    break;
                case 'reviews':
                    if (this.instrumentType && this.id) {
                        return this.urlRoot + 'cdr/applications/' + this.instrumentType + '/' + this.id + '/reviews?Page=[{Max:0}]';
                    }
                    break;
                case 'conditions':
                    if (this.instrumentType && this.id) {
                        return this.urlRoot + 'cdr/applications/' + this.instrumentType + '/' + this.id + '/conditions?Page=[{Max:0}]';
                    }
                    break;
                case 'planningconditions':
                    if ((this.instrumentType == 'building' || this.instrumentType == 'planning' || this.instrumentType == 'project') && this.id) {
                        return this.urlRoot + 'cdr/applications/' + this.instrumentType + '/' + this.id + '/planningconditions?Page=[{Max:0}]';
                    }
                    break;
                case 'planningconditionscompleted':
                    if ((this.instrumentType == 'building' || this.instrumentType == 'planning' || this.instrumentType == 'project') && this.id) {
                        return this.urlRoot + 'cdr/applications/' + this.instrumentType + '/' + this.id + '/planningconditions?extendedFilter=[{operator:And,nest:[{operator:Or,criteria:[{Property:PlanningCondition.Status.IsConditionMet,Value:Y},{Property:PlanningCondition.Status.IsConditionMarkedAsDeleted,Value:Y},{Property:PlanningCondition.Status.IsConditionDeferredMilestoneEnabled,Value:Y}]}]}]&Page=[{Max:0}]';
                    }
                    break;
                case 'logs':
                    if (this.instrumentType && this.id) {
                        if (this.instrumentType == 'servicerequest') {
                            return this.urlRoot + 'crm/' + this.instrumentType + 's/' + this.id + '/logs?Page=[{Max:0}]';
                        }
                        return this.urlRoot + 'cdr/applications/' + this.instrumentType + '/' + this.id + '/logs?Page=[{Max:0}]';
                    }
                    break;
                case 'relatedrecords':
                    if (this.instrumentType == 'servicerequest' && this.id) {
                        if( this.accountId ){   //this is for billing
                            return this.urlRoot + 'crm/servicerequests/' + this.id + '/servicerequests?AccountId=' + this.accountId + '&Page=[{Max:0}]';
                        } else {
                            return this.urlRoot + 'crm/servicerequests/' + this.id + '/servicerequests?Page=[{Max:0}]';
                        }      
                    } else if (this.instrumentType && this.commonID) {
                        return this.urlRoot + 'cdr/common/applications/' + this.commonID + '/relatedapplications?Page=[{Max:0}]&lightweightextensions=true';
                    }
                    break;
                case 'hearings':
                    if ((this.instrumentType == 'codeenforcement' || this.instrumentType == 'planning' || this.instrumentType == 'project') && this.id) {
                        let selectFilter = ViewManager.versionRange('8.8.0.2307') ? '&Select=[id,Attendees.Comments,Attendees.Name,Attendees.Title,Comments,Details.Comments,Details.HearingId,Details.id,Details.Comments,CompleteDateTime,Details,DocketNumber,HearingType.Description,HearingType.PortalDescription,Location,Result,ResultDescription,ResultNotes,ScheduleDateTime,StartDateTime,Application.IsClosedInPortal,Application.Id]':'';                  
                        return this.urlRoot + 'cdr/applications/' + this.instrumentType + '/' + this.id + '/hearings?Page=[{Max:0}]' + selectFilter;
                    }
                    break;
                case 'servicerequestrelatedrecord':         //Load  cases linked to a service reequest
                    if (this.instrumentType == 'servicerequest' && this.id) {
                        if(AvailableFeatures.ViewServiceRequestAssociations()){
                            if( this.accountId )   //this is for billing
                                return this.urlRoot + 'crm/servicerequests/' + this.id + '/relatedrecords?AccountId=' + this.accountId + '&Page=[{Max:0}]';
                            else
                                return this.urlRoot + 'crm/servicerequests/' + this.id + '/relatedrecords?Page=[{Max:0}]';
                        } else
                            return this.urlRoot + 'crm/servicerequests/' + this.id + '/cases?Page=[{Max:0}]';
                    }
                    break;
                case 'cdrservicerequests':         //Load service requests linked to a cdr
                    if (this.commonID) {
                        return this.urlRoot + 'cdr/common/applications/' + this.commonID + '/servicerequests?Page=[{Max:0}]';
                    }
                    break;

            }
            return 'error';
        },
        parse: function(response) {
            var data = response.data;
            switch (this.itemType.toLowerCase()) {
                case 'inspections':
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].result && data[i].result.trim().length > 0 ) {
                            data[i].completed = true;
                        } else {
                            data[i].completed = false;
                        }
                    }
                    break;
                case 'fees':
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].totalUnpaidAmount > 0) {
                            data[i].completed = false;
                        } else {
                            data[i].completed = true;
                            if (data[i].status.toLowerCase() != 'paid') {
                                data[i].status = 'Paid';
                                data[i].hideOptions = true;
                            }
                        }
                    }
                    break;
                case 'reviews':
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].result && data[i].result.trim().length > 0) {
                            data[i].completed = true;
                        } else {
                            data[i].completed = false;
                        }
                    }
                    break;
                case 'conditions':
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].approvalCode && data[i].approvalCode.trim().length > 0) {
                            data[i].completed = true;
                        } else {
                            data[i].completed = false;
                        }
                    }
                    break;
                case 'planningconditions':
                    break;
                case 'planningconditionscompleted':
                    break;
                case 'logs':
                    for (var i = 0; i < data.length; i++) {
                        if( this.instrumentType == 'servicerequest'){
                            data[i].startDateTime = data[i].start;
                            data[i].description = data[i].type.description && data[i].type.description.trim().length > 0 ? data[i].type.description : i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
                        }
                        else{
                            if( data[i].description == null || data[i].description.trim().length <= 0 ){
                                data[i].description = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
                            }
                        }
                    }
                    break;
                case 'relatedrecords':
                    $.each(data, function(index, el) {
                        el.instrumentType = this.instrumentType;
                        var CPQType = ViewManager.globalConfig().get('wizardProjectType') ? ViewManager.globalConfig().get('wizardProjectType').toLowerCase().trim() : "";
                        if (el.instrumentType != 'servicerequest') {
                            if (this.commonID == el.ap1Id && el.ap2) {
                                el.linkID = el.ap2.id;
                                el.recordType = el.ap2CdrProductFamily.toLowerCase();
                                el.displayID = el.ap2.applicationNumber;
                                el.displayDescription = (el.ap2.applicationType.portalDescription) ? el.ap2.applicationType.portalDescription : el.ap2.applicationType.description;
                                el.id = el.recordType + el.id;      //make id unique across families

                                //do not display CPQ parent
                                if( el.recordType === "project"){
                                    if( el.ap2.applicationType.code.toLowerCase() == CPQType ){
                                        el.hide = true;
                                    }
                                }
                            } else if (el.ap1) {
                                el.linkID = el.ap1.id;
                                el.recordType = el.ap1CdrProductFamily.toLowerCase();
                                el.displayID = el.ap1.applicationNumber;
                                el.displayDescription = (el.ap1.applicationType.portalDescription) ? el.ap1.applicationType.portalDescription : el.ap1.applicationType.description;
                                el.id = el.recordType + el.id;      //make id unique across families

                                //do not display CPQ parent
                                if( el.recordType === "project"){
                                    if( el.ap1.applicationType.code.toLowerCase() == CPQType ){
                                        el.hide = true;
                                    }
                                }
                            }
                        } else {
                            el.recordType = 'servicerequest';
                            el.linkID = el.id;
                            el.displayID = el.id;
                            el.displayDescription = el.requestType.portalDescription ? el.requestType.portalDescription : el.requestType.description;
                            el.id = el.recordType + el.id;          //make id unique across families

                            //do not display CPQ parent
                            if( el.recordType === "project"){
                                if( el.requestType.code.toLowerCase() == CPQType ){
                                    el.hide = true;
                                }
                            }
                        }
                    }.bind(this));
                    break;
                case 'hearings':
                  for (var i = 0; i < data.length; i++) {
                      if (data[i].result && data[i].result.trim().length > 0) {
                          data[i].completed = true;
                      } else {
                          data[i].completed = false;
                      }
                  }
                  break;
                case 'servicerequestrelatedrecord':
                    var newArray = [];
                    $.each(data, function(index, el) {
                        if (el.id) {
                            el.instrumentType = this.instrumentType; 
                            el.recordType = instrument_utilities.getInstrumentType(el.applicationType.instrumentTypeID); // convert instrument id to intrument type
                            el.cannotDelete = true;
                            el.linkID = el.id;
                            el.displayID = el.applicationNumber;
                            el.displayDescription = el.applicationType.portalDescription ? el.applicationType.portalDescription : el.applicationType.description;
                            el.id = el.recordType + el.id;          //make id unique across families
                            newArray.push(el);
                        }
                    }.bind(this));
                    data = newArray;
                    break;
                case 'cdrservicerequests':
                    var newArray = [];
                    $.each(data, function(index, el) {
                        if (el.id) {
                            el.instrumentType = this.instrumentType;
                            el.recordType = 'servicerequest';
                            el.cannotDelete = true;
                            el.linkID = el.id;
                            el.displayID = el.id;
                            el.displayDescription = el.requestType.portalDescription ? el.requestType.portalDescription : el.requestType.description;
                            el.id = el.recordType + el.id;          //make id unique across families
                            newArray.push(el);
                        }
                    }.bind(this));
                    data = newArray;
                    break;
            }
            if (Array.isArray(data)) {
                data = data.filter((item) => {
                    //if the item has no id, we don't want to have an impact.
                    //if it does, make sure we have a useful ID
                    return item.id == null || (item.id != 1 && item.id != 0)
                });
            }
            return data;

        },
    });
});
